import React from "react";
import { useTranslation } from "react-i18next";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { resetSheetState } from "../actions";
import { DropdownItem } from "semantic-ui-react";

const ResetSheetState = ({ sheet, onSubmitted, sheetActionRequired }) => {
  const { t } = useTranslation("agreements");

  const { sheetId, sheetName, availableActionsIps, availableActionsPrincipal } =
    sheet;

  if (
    (process.env.TRADE_AS_IPS && !availableActionsIps[sheetActionRequired]) ||
    (!process.env.TRADE_AS_IPS &&
      !availableActionsPrincipal[sheetActionRequired])
  ) {
    return null;
  }

  return (
    <ModalBuilder
      withForm
      submitAction={resetSheetState}
      submitParams={{ sheetId }}
      onSubmitted={onSubmitted}
      renderError={false}
      renderSubmitting={false}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.ResetSheetState.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal.Confirmation
          {...modalProps}
          header={t("SheetActions.ResetSheetState.HeaderText")}
        >
          {t("SheetActions.ResetSheetState.ConfirmationText", {
            sheetName: sheetName,
          })}
        </TranslatedModal.Confirmation>
      )}
    />
  );
};

export default ResetSheetState;
